<template>
  <div class="audits-wrapper">
    <div class="audits-container">
      <div class="title">Trust</div>
      <div class="trust-content">
        <Security />
        <Team />
      </div>
    </div>
  </div>
</template>

<script setup>
import Security from './Security.vue';
import Team from './Team.vue';
</script>

<style scoped>
.audits-wrapper {
  max-width: 1180px;
  margin: 0 auto 80px auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;

  @media only screen and (max-width: 768px) {
    display: flex;
    justify-content: space-between;
  }
}

.trust-content {
  display: grid;
  grid-template-columns: auto auto;
  gap: 30px;

  @media only screen and (max-width: 1120px) {
    grid-template-columns: 1fr;
  }
}

.title {
  text-transform: uppercase;
  margin-bottom: 30px;

  @media only screen and (max-width: 768px) {
    margin-bottom: 10px;
    font-size: 14px;
  }
}
</style>
